import { fromPostgrest, guard, type Result } from '@/lib/result';
import { supabase } from '@/lib/supabase';

import { mapNotification, type AppNotification } from '../model/notification';

const SELECT = 'id, type, title, body, related_request_id, created_at, read_at';

export const notificationsRepository = {
  /** Upsert a device push token for the signed-in user (token is unique). */
  async registerToken(userId: string, token: string): Promise<Result<void>> {
    return guard(async () => {
      const { error } = await supabase
        .from('notification_tokens')
        .upsert(
          { user_id: userId, token, platform: 'web', last_seen_at: new Date().toISOString() },
          { onConflict: 'token' },
        );
      if (error) throw fromPostgrest(error);
    });
  },

  async removeToken(token: string): Promise<Result<void>> {
    return guard(async () => {
      const { error } = await supabase.from('notification_tokens').delete().eq('token', token);
      if (error) throw fromPostgrest(error);
    });
  },

  async listMine(): Promise<Result<readonly AppNotification[]>> {
    return guard(async () => {
      const { data, error } = await supabase
        .from('notifications')
        .select(SELECT)
        .order('created_at', { ascending: false })
        .limit(50);
      if (error) throw fromPostgrest(error);
      return ((data ?? []) as unknown[]).map(mapNotification);
    });
  },

  async markRead(id: string): Promise<Result<void>> {
    return guard(async () => {
      const { error } = await supabase
        .from('notifications')
        .update({ read_at: new Date().toISOString() })
        .eq('id', id);
      if (error) throw fromPostgrest(error);
    });
  },
};
